import { useQuery } from "@tanstack/react-query";
import agentsService from "services/admin/AgentsService";

export const useGetAIFunctions = (agentID, queryParams = {}) => {
    return useQuery({
        queryKey: ['getAIFunctions', agentID, queryParams],
        enabled: !!agentID,
        queryFn: async () => {
            const { data } = await agentsService.getAIFunctions(agentID, queryParams)
            return data
        },
        retry: false,
        refetchOnWindowFocus: false,
    })
}